import { useTranslation } from 'react-i18next'
import React from 'react'

import { useEntityRootNavigation } from '../../../utils/routes/entityRoot'
import { useOpenImportHistoryModal } from '../../../utils/routes/modals/modalsActions'
import { usePlaceTypeName } from '../../../utils/helpers/placeTypes'
import IconButton from '../../../components/actions/IconButton'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'

const PageHeader = ({ entity }) => {
  const returnAction = useEntityRootNavigation(entity)
  const openImportHistoryModal = useOpenImportHistoryModal()
  const { t } = useTranslation(['import', 'common'])

  let name = usePlaceTypeName(entity, true)
  if (!name) name = t('common:entity.' + entity)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={returnAction}
      title={t('title') + name}
      mediumPadding
      noContainer
      side={
        <IconButton
          icon="RiTimeLine"
          color="white"
          onClick={() => openImportHistoryModal(entity)}
          transparent
          label={t('history')}
        />
      }
    />
  )
}

export default PageHeader
